import { WhatsNew } from "@/common/model/WhatsNew";
import { WhatsNewRequestDTO } from "@/common/model/dto/request/WhatsNewRequest.dto";
import { WhatsNewResponseDTO } from "@/common/model/dto/response/WhatsNewResponse.dto";
import { formatDateForZonedDateTime } from "@/helpers/date.helper";
import { getStatusFromDates } from "@/utils/dateUtils";

/**
 * Mapper for converting between WhatsNew model and DTOs
 * Uses shared date utilities for consistent date handling
 */
export const WhatsNewMapper = {
  fromResponse(dto: WhatsNewResponseDTO): WhatsNew {
    const startDate = new Date(dto.startDate);
    const endDate = new Date(dto.endDate);

    return {
      id: dto.id,
      title: dto.title,
      startDate,
      endDate,
      url: dto.url || "",
      status: getStatusFromDates(startDate, endDate),
    };
  },

  toRequest(model: Partial<WhatsNew>): WhatsNewRequestDTO {
    return {
      title: model.title || "",
      startDate: model.startDate
        ? formatDateForZonedDateTime(model.startDate)
        : "",
      endDate: model.endDate ? formatDateForZonedDateTime(model.endDate) : "",
      url: model.url,
    };
  },
};
